import React from 'react';
import { useFocusEffect } from '@react-navigation/native';

import { Bag } from '@order/features/ordering';
import { useCloseBag } from '@order/hooks';
import { useFeatureFlag } from '@order/LaunchDarkly';

import { BagAnimatedDialog, BagContent } from './components';
import { useBagGestures, useOrderState } from './hooks';

export const BagScreen = () => {
  const isExpressPaymentsEnabled = useFeatureFlag(
    'permanent-order-stripe-express-checkout-enabled',
  );

  const orderState = useOrderState({ isExpressPaymentsEnabled });

  const { isShowingModal, startOrdering } = orderState;

  // ──────────────────────────────────────────────────────────────────────────

  const closeBag = useCloseBag();

  // Enable/disable gestures when modal is shown.
  useBagGestures(isShowingModal);

  // Fetch ordering data on bag focus.
  useFocusEffect(startOrdering);

  // ──────────────────────────────────────────────────────────────────────────

  return (
    <Bag.DynamicModal onClose={closeBag}>
      <BagContent orderState={orderState} />

      <BagAnimatedDialog orderState={orderState} />
    </Bag.DynamicModal>
  );
};
